import StringInput from "components/Atoms/StringInput"
import FormController from "components/Molecules/FormController"

import Note from "components/Atoms/Note"
import dayjs from "dayjs"
import customFormat from "dayjs/plugin/customParseFormat"
import React from "react"
import styles from "./dc.module.scss"
import useDCStore from "./dc.store"
import FormLayout from "./FormLayout"
dayjs.extend(customFormat)

const StockPreferences = () => {
  const [currentStockPercentage, errors, setCurrentStockPercentage, disabled] =
    useDCStore(store => [
      store.state.stockPreferences,
      store.errors.stockPreferences?.details,
      store.setData("stockPreferences"),
      store.disabled,
    ])
  return (
    <FormController
      disableAll={true}
      disabled={disabled}
      errors={errors}
      source={currentStockPercentage}
      onChange={setCurrentStockPercentage}
    >
      <FormLayout className={styles.grid} title="Stock Broadcast Preferences">
        <StringInput
          min={0}
          max={100}
          big={false}
          type="number"
          path="currentStockPercentage"
          label="Stock Broadcast Percentage"
        />
        <Note intent="warning" style={{ gridColumn: "2/4" }}>
          <span className="font-700">Note: </span> This percent of ground stock
          will be visible in <b>every stock</b> of this Distribution Center for
          online bookings.
        </Note>
      </FormLayout>
    </FormController>
  )
}

export default StockPreferences
